module.exports = __webpack_public_path__ + "img/img9.d1f33a1f.svg";